import sanitizeHtml from "sanitize-html";
import router from "../router";
import marked from "marked";

const intercept = (urlmatch, callback) => {
  let send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function (body) {
    this.addEventListener(
      "readystatechange",
      function () {
        if (this.responseURL.match(urlmatch) && this.readyState === 4) {
          callback(this, arguments, body);
        }
      },
      false
    );
    send.apply(this, arguments);
  };
};

const openInTab = (url) => {
  window.location = url;
};

const uuidv4 = () => {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
    (
      c ^
      (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
    ).toString(16)
  );
};

const capitalize = (s) => {
  if (typeof s !== "string") return "";
  return s.charAt(0).toUpperCase() + s.slice(1);
};

const isMobile = function () {
  var check = false;
  (function (a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
        a
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4)
      )
    )
      check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
};

function injectScript(src) {
  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.async = true;
    script.src = src;
    script.addEventListener("load", resolve);
    script.addEventListener("error", () => reject("Error loading script."));
    script.addEventListener("abort", () => reject("Script loading aborted."));
    document.head.appendChild(script);
  });
}

function injectStylesheet(src) {
  return new Promise((resolve, reject) => {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = src;
    link.addEventListener("load", resolve);
    link.addEventListener("error", () => reject("Error loading stylesheet."));
    link.addEventListener("abort", () => reject("Stylehseet loading aborted."));
    document.head.appendChild(link);
  });
}

function is_localhost() {
  return (
    document.location.hostname.includes("ngrok") ||
    document.location.hostname == "localhost" ||
    document.location.hostname == "127.0.0.1"
  );
}

function is_development() {
  return process.env.NODE_ENV === "development";
}

function starts_with_http(text) {
  return text.substr(0, 4) == "http";
}

function convert_textlinks_to_links(text) {
  var expression = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)|[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/;

  var regex = new RegExp(expression);

  var matches = regex.exec(text);
  var textlink_replaced = [];
  if (matches) {
    matches.map((textlink) => {
      console.log("MATCH", textlink);
      if (text.split(" ").includes(textlink)) {
        console.log("textlink", textlink);
        var textlink_url = textlink;
        if (!textlink_replaced.includes(textlink)) {
          text = text.replace(
            textlink,
            '<a class="chat-box-textlink" target="_blank" href="' +
            textlink_url +
            '">' +
            textlink +
            "</a>"
          );
          textlink_replaced.push(textlink);
        }

        console.log("text", text);
      }
    });
  }
  return text;
}

function CleanTextEnterd(dirty) {
  let clean = sanitizeHtml(dirty, {
    allowedTags: [
      "b",
      "i",
      "em",
      "strong",
      "a",
      "u",
      "s",
      "ol",
      "li",
      "br",
      "span",
      "p",
      "code",
    ],
    allowedSchemes: ["http", "https", "ftp", "mailto", "tel"],
    allowedAttributes: {
      a: ["href", "target"],
      span: ["style"],
    },
    allowedIframeHostnames: [],
    allowedStyles: {
      "*": {
        // Match HEX and RGB
        color: [
          /^#(0x)?[0-9a-f]+$/i,
          /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/,
        ],
        "text-align": [/^left$/, /^right$/, /^center$/],
        // Match any number with px, em, or %
        "font-size": [/^\d+(?:px|em|%)$/],
      },
    },
  });
  console.log("-->", clean);
  return clean;
}

function CleanTextReceived(dirty) {
  let clean = sanitizeHtml(dirty, {
    allowedTags: [
      "b",
      "i",
      "em",
      "strong",
      "a",
      "u",
      "s",
      "ol",
      "ul",
      "li",
      "br",
      "span",
      "p",
      "a",
      "code",
    ],
    allowedSchemes: ["http", "https", "ftp", "mailto", "tel"],
    allowedAttributes: {
      a: ["href", "target"],
      span: ["style"],
    },
    allowedIframeHostnames: [],
    allowedStyles: {
      "*": {
        // Match HEX and RGB
        color: [
          /^#(0x)?[0-9a-f]+$/i,
          /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/,
        ],
        "text-align": [/^left$/, /^right$/, /^center$/],
        // Match any number with px, em, or %
        "font-size": [/^\d+(?:px|em|%)$/],
      },
    },
  });
  return clean;
}

function convertMardownToHTML(text) {
  try {
    const renderer = new marked.Renderer();

    function escapeHtml(input) {
      return input
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/\"/g, "&quot;")
        .replace(/'/g, "&#39;");
    }

    // More robust HTML entity decoder that preserves Unicode characters
    const decodeHTMLEntities = (text) => {
      const textarea = document.createElement("textarea");
      textarea.innerHTML = text;

      // Replace Unicode escape sequences with actual characters
      let decodedText = textarea.value;

      // Handle Unicode escape sequences like \u202f
      decodedText = decodedText.replace(
        /\\u([0-9a-fA-F]{4})/g,
        (match, hexCode) => {
          return String.fromCodePoint(parseInt(hexCode, 16));
        }
      );

      return decodedText;
    };

    // Decode any HTML entities (like &#9986;)
    const decoded = decodeHTMLEntities(text);

    // 1. Set up custom renderer to make links open in new tabs
    renderer.link = function (href, title, text) {
      const link = new marked.Renderer().link(href, title, text);
      return link.replace(
        "<a",
        '<a target="_blank" rel="cleed noopener noreferrer"'
      );
    };

    // 2. Remove images from the output (convert image markdown to just the alt text)
    renderer.image = function (href, title, text) {
      const alt = text ? escapeHtml(text) : "";
      const linkHref = href || "#";
      const titleAttr = title ? ` title="${escapeHtml(title)}"` : "";
      return `- <a target="_blank" alt="${alt}"${titleAttr} rel="cleed noopener noreferrer" href="${linkHref}">Image: ${alt}</a>`;
    };

    // 4. Replace \n with actual line breaks before parsing
    const normalizedMarkdown = decoded.replace(/\\n-/g, "\n -").replace(/\\n/g, "\n");

    let htmlString = marked.parse(normalizedMarkdown, {
      renderer,
      gfm: true,
      breaks: true,
    });

    // 5. Post-process tables to wrap in responsive container and add classes
    if (typeof htmlString === "string") {
      htmlString = htmlString
        .replace(/<table>/g, '<table class="markdown-table">')
        .replace(/<table([\s>])/g, '<table class="markdown-table"$1')
        .replace(
          /<table[^>]*>/g,
          (match) => `<div class="markdown-table-wrapper">${match}`
        )
        .replace(/<\/table>/g, "</table></div>");
    }
    const template = document.createElement("template");
    template.innerHTML = htmlString;
    return template.innerHTML;
  } catch (e) {
    console.error("Error converting markdown to HTML:", e);
    return text;
  }
}

function checkPathMeta(pathname) {
  const find = router.options.routes.filter((path) => {
    return pathname == path.path;
  });
  if (find[0] && find[0].meta && find[0].meta.requiresAuth) return true;
  return false;
}

export default {
  intercept,
  openInTab,
  uuidv4,
  capitalize,
  isMobile,
  injectScript,
  injectStylesheet,
  is_localhost,
  is_development,
  convert_textlinks_to_links,
  CleanTextReceived,
  CleanTextEnterd,
  convertMardownToHTML,
  checkPathMeta,
};
